// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__OWY2s","checkmark":"CheckBox_checkmark__br2QQ","error":"CheckBox_error__in5c0"};